import {createSelector} from '@reduxjs/toolkit'
import {currentAgentApplicationSelector} from './collectorApplicationSelector'
import {companyPeopleListSelector} from './companyPeopleListSelector'
import {fullName, humanReadableDate} from '../../app/utils'

const criminalHistoryQuestionSelector = createSelector(
    [state => state.components,
        currentAgentApplicationSelector],
    (components, agentApplication) => {
        let criminalHistoryQuestion = components.criminalHistoryQuestion

        return Object.assign({},criminalHistoryQuestion, {
            collectorApplication : agentApplication?.businessLicenceData
        })
    }
)

export const criminalHistoryQuestionSelect = state => ({
    criminalHistoryQuestion: criminalHistoryQuestionSelector(state)
})

const criminalHistoryDetailsSelector = createSelector(
    [state => state.components,
        state => state.primaryAgencyApplication.application?.businessLicenceData,
        currentAgentApplicationSelector,
        companyPeopleListSelector],
    (components,appData,agentApplication, peopleList) => {
        let criminalHistoryList = []

        if(appData && appData.criminalHistoryData)
            criminalHistoryList = appData.criminalHistoryData

        return Object.assign({},
            components.criminalHistoryDetails,
            {
                criminalHistoryList,
                peopleList,
                collectorApplicantDetails : agentApplication?.businessLicenceData?.applicantDetails,
                collectorCriminalHistoryDetails : agentApplication?.businessLicenceData?.criminalHistoryData,
                collectorLicenceSuspensionData : agentApplication?.businessLicenceData?.licenceSuspendedData
            })
    }
)

export const criminalHistoryDetailsSelect = state => ({
    criminalHistoryDetails: criminalHistoryDetailsSelector(state)
})

export function populateCriminalHistoryListQuestionForReview(criminalList) {
    if(!criminalList || (Array.isArray(criminalList) && criminalList.length === 0)) {
        return {
            "Have any of your directors, partners, or officers been convicted of an offence for which they have not been pardonded?" : "No"
        }
    }

    return {
        "Have any of your directors, partners, or officers been convicted of an offence for which they have not been pardonded?" : "Yes",
    }
}

export function populateCriminalHistoryListDataForReview(criminalList) {
    let data = []

    if(criminalList) {
        criminalList.forEach((criminal) => {
            let obj = {}

            if(criminal.people) { 
                let name = fullName(criminal.people)
                let position = criminal.people.position

                if(position) {
                    name = name + ", " + position
                }

                obj["Name"] = name
            }
            obj["Date of offence"] = criminal.dateOfOffence ? humanReadableDate(criminal.dateOfOffence) : ""
            obj["Description of offence"] = criminal.description ? criminal.description : ""
            data.push(obj)
        } )
    }

    return data
}
